import { throttle, debounce } from "lodash";
import { EventBus } from "../index.js";
import { KEYS } from "../../utilities";

export default {
	data() {
		return {
			scrollDisabled: false
		};
	},
	methods: {
		onResize(e) {
			/**
			 * This method should be used by the vue-breakpoint-component
			 * <v-breakpoint @change="onResize"/>
			 */
			EventBus.$emit("window:resize", e);
		},
		_onScroll(e) {
			EventBus.$emit("window:scroll", e);
			this._setScrollDirection();
		},
		_throttledScroll(e) {
			EventBus.$emit("window:scroll:throttled", e);
		},
		_onKeyup(e) {
			let key = e.which || e.keyCode;
			// Page level keyup event to help dismiss things like modals, overlays, etc
			if (key === KEYS.ESC) {
				EventBus.$emit("keyup:esc", e);
			}
			EventBus.$emit("keyup", e);
		},
		_onClickTap: debounce(function (e) {
			// use these to listen to generic page level click events to help you
			// dismiss things when tapping anywhere else on the page

			if (EventBus.USER_IS_TOUCHING) {
				EventBus.$emit("page:touchend", e);
				return;
			}

			EventBus.$emit("page:click", e);
		}, 150),
		_setScrollDirection() {
			// https://stackoverflow.com/a/31223774

			const st = window.pageYOffset || document.documentElement.scrollTop;
			if (st > this._lastScrollTop) {
				EventBus.scrollDirection = "down";
			} else {
				EventBus.scrollDirection = "up";
			}
			this._lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
		},
		_isMobileOS() {
			const ua = window.navigator.userAgent;
			const iphone = ua.match(/iPhone/);
			const android = ua.match(/android/i);

			return iphone || android;
		}
	},
	beforeCreate() {
		this._lastScrollTop = 0;
		window.addEventListener("touchstart", function onFirstTouch() {
			EventBus.USER_IS_TOUCHING = true;
			window.removeEventListener("touchstart", onFirstTouch);
		});
	},
	mounted() {
		this._lastScrollTop = 0;
		document.addEventListener("keyup", this._onKeyup);
		window.addEventListener("scroll", this._onScroll);
		window.addEventListener("scroll", throttle(this._throttledScroll, 150));
		document.addEventListener("click", this._onClickTap);
		document.addEventListener("touchend", this._onClickTap);

		if (
			window.innerWidth !== document.body.clientWidth &&
			!this._isMobileOS()
		) {
			document.querySelector("html").classList.add("scrollbar-visible");
		}

		// Bind scrollDisabled to events
		EventBus.$on("scroll:disable", () => {
			this.scrollDisabled = true;
		});

		EventBus.$on("scroll:enable", () => {
			this.scrollDisabled = false;
		});
	},
	beforeDestroy() {
		// these might not be necessary at the App.vue level
		document.removeEventListener("keyup", this._onKeyup);
		window.removeEventListener("scroll", this._onScroll);
		document.removeEventListener("click", this._onClickTap);
		document.removeEventListener("touchend", this._onClickTap);
	}
};
